// Self-contained data for the Base Function Hall events concept website.
export const BUSINESS = {
  "slug": "base-function-hall-concept",
  "media": {
    "hero": "/events/base/03.jpg",
    "logo": "/events/base/18.jpg",
    "gallery": [
      "/events/base/01.jpg",
      "/events/base/02.jpg",
      "/events/base/04.jpg",
      "/events/base/05.jpg",
      "/events/base/06.jpg",
      "/events/base/07.jpg",
      "/events/base/08.jpg",
      "/events/base/09.jpg",
      "/events/base/10.jpg",
      "/events/base/11.jpg",
      "/events/base/12.jpg",
      "/events/base/13.jpg",
      "/events/base/14.jpg",
      "/events/base/15.jpg",
      "/events/base/16.jpg"
    ]
  },
  "name": "Base Function Hall",
  "shortName": "Base",
  "kind": "venue",
  "layout": "indoor",
  "location": "Bacolod City",
  "address": "5th Floor, Base Building, Lacson St., Bacolod City, Negros Occidental, Philippines",
  "eyebrow": "A Bacolod venue for celebrations and professional functions",
  "headline": "See the room. Shape the setup. Plan the occasion.",
  "intro": "A clear view of Therese Hall, its event configurations and the path to checking availability.",
  "venueFeature": "Therese Hall",
  "capacity": "Up to 120 guests",
  "services": [
    "Weddings",
    "Birthdays",
    "Family celebrations",
    "Professional seminars and training",
    "Community events",
    "Venue and food-package enquiries"
  ],
  "proof": [
    "Therese Hall capacity publicly stated as up to 120",
    "Central Lacson Street location",
    "Celebration and professional-event use"
  ],
  "reviewSnapshot": "Public rating last checked in August 2026: about 4.6/5 from approximately 53 reviews.",
  "reviews": [
    {
      "author": "Janette Benito",
      "summary": "Praised the spacious, clean venue, accommodating staff and the convenience of an all-in package.",
      "source": "https://venuekonnex.com/listing/the-venue-at-bacolod/",
      "explicitStars": 5,
      "context": "Venue and package"
    },
    {
      "author": "Cici Koh",
      "summary": "Highlighted attentive communication, smooth booking and an excellent function-hall experience.",
      "source": "https://venuekonnex.com/listing/the-venue-at-bacolod/",
      "explicitStars": 5,
      "context": "Booking experience"
    },
    {
      "author": "RJM Travel and Tours",
      "summary": "Described it as one of Bacolod’s best function rooms and mentioned an 80th birthday celebration there.",
      "source": "https://venuekonnex.com/listing/the-venue-at-bacolod/",
      "explicitStars": 5,
      "context": "Milestone celebration"
    },
    {
      "author": "Local parent",
      "summary": "Reported liking the food and the convenience of a first-birthday package that included several event elements.",
      "source": "https://www.reddit.com/r/Bacolod/comments/1jkzbn9/",
      "explicitStars": null,
      "context": "Community experience"
    }
  ],
  "contact": {
    "phone": "(034) 432-7092",
    "phoneHref": "+63344327092",
    "facebook": "https://www.facebook.com/basefunctionhall/",
    "instagram": "https://www.instagram.com/basefunctionhall/"
  },
  "sources": [
    "https://www.facebook.com/basefunctionhall/",
    "https://www.instagram.com/basefunctionhall/",
    "https://www.facebook.com/basefunctionhall/posts/welcome-to-therese-hall-at-base-function-hall-where-grand-celebrations-come-to-l/905829811549892/",
    "https://venuekonnex.com/listing/the-venue-at-bacolod/"
  ]
};
